module.exports = __webpack_public_path__ + "static/media/Weibu05.c3b402b9.jpg";